import React, {useEffect, useState, useContext, Fragment} from 'react';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import {Button} from "react-bootstrap";
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import Images from 'assets/images/imageData';
import ModalPop from "components/sales/modal/modal";
import {Link} from "react-router-dom";
import {BaseUrl} from "contexts/baseUrl/baseUrl";
import {updateHotoStatus} from "../../../services/redux/maintenance/hoto/action";
import DivLayout from 'components/sales/divLayout/divLayout';
import '../hotoMainForm/hoto.css';

const HotoApproval = (
  {
    match,
    postHotoMaintenance,
    getHotoDetails,
    hotoDetails,
    updateHotoStatus
  }
) => {

  const [isLoading, setIsLoading] = useState(false);
  const [inputImage, setImageList] = useState([{url: "", content: "", material_id: ""}]);
  const [listData, setRepositoryData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [hotoId, setHotoId] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const {baseUrl} = useContext(BaseUrl);
  const [modalMsg, setMessage] = useState('');
  const [currentIter, setCurrentIter] = useState();
  const [previousIter, setPreviousIter] = useState();
  const [iterCount, setIterCount] = useState();

  const input = {
    remarks: '',
  };
  const [remarks, setRemarks] = useState(input);
  const [isRejectModal, setIsRejectModal] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true)
      getHotoDetails(match.params.id);
      setIsLoading(false)
    })()
  }, [])

  useEffect(() => {
    if (hotoDetails && hotoDetails?.currentIter) {
      setCurrentIter(hotoDetails?.currentIter);
      if (hotoDetails?.prevIter) {
        setPreviousIter(hotoDetails?.prevIter);
        setIterCount(hotoDetails?.prevIter.length);
      }
    }
  }, [hotoDetails]);

  const headers = ['Id', 'Name', 'Description'];


  const handleImageContent = (val, index) => {
    const list = [...inputImage]
    list[index]['content'] = val
    setImageList([...list])
  }
  const handleMaterial = (val, index) => {
    const list = [...inputImage]
    list[index]['material_id'] = val
    setImageList([...list])
  }

  const saveImage = (val, index) => {
    const list = [...inputImage]
    list[index]['url'] = val
    setImageList([...inputImage])
  }

  const handleImageAdd = () => {
    setImageList(
      [
        ...inputImage, {
        url: '',
        content: '',
        material_id: ''
      }
      ]
    )
  }

  const handleImageRemove = index => {
    const list = [...inputImage];
    list.splice(index, 1);
    setImageList(list);
  }
  // {setHotoId(value?.hoto_id)}

  const handleApprove = () => {
    setIsLoading(true);
    //Check if approved by maintenance head
    var data = {};
    if (hotoDetails.hotoData?.status == 3) {
      data = {
        'hoto_id': match.params.id,
        'status': '4'
      }
    } else {
      data = {
        'hoto_id': match.params.id,
        'status': '9'
      }
    }
    const res = updateHotoStatus(data);

    // setIsLoading(false)
    // console.log(res);return;

    if (res) {
      setMessage('Approved!');
      setIsModal(true);
    } else {
      setMessage('Not approved!');
      setIsModal(true);

    }

    setIsLoading(false)
  }
  const handleReject = () => {
    setIsLoading(true)
    //Check if approved by maintenance head
    var data = {};
    if (hotoDetails.hotoData?.status == 3) {
      data = {
        'hoto_id': match.params.id,
        'status': '5',
        'remarks': remarks.remarks
      }
    } else {
      data = {
        'hoto_id': match.params.id,
        'status': '8',
        'remarks': remarks.remarks
      }
    }
    const res = updateHotoStatus(data);
    console.log(JSON.stringify(res));
    if (res) {
      setMessage('Saved!');
      setIsModal(true);
    } else {
      setMessage('Not Saved!');
      setIsModal(true);
    }
    setIsLoading(false)
  }

  const handleModalHide = async () => {
    // setIsDefalut(true);
    setIsModal(false);
  };

  const openRejectModal = async () => {
    setIsRejectModal(true);
  };

  {
    // console.log(previousIter)
  }
  return (
    <Layout
      title={localization.maintenanceTesting}
      isLoading={isLoading}
      isGoback={true}
    >
      <>
        <div className="container-fluid mb-0">
          {currentIter && currentIter?.length > 0 &&
            <div className='card mb-2'>
              <div className="card-header mb-3 bg_style">
                Current HOTO
                <span className='r-shiwt'>
                  ME: <b>{currentIter?.[0]?.m_name} ({currentIter?.[0]?.me_created_at})</b>
                </span>
                <span className='r-shiwt m-right'>
                  SE: {currentIter?.[0]?.i_name && <b>{currentIter?.[0]?.i_name} ({currentIter?.[0]?.se_updated_at})</b> }
                </span>
              </div>
              <div className="card-body ml-2 mr-2">
                <table className='panel-table table table-striped mb-2' width="100%">
                  <thead>
                  <tr>
                    <th> Material</th>
                    <th> Maintenance Images</th>
                    <th> Material Status</th>
                    <th> Maintenance Remark</th>
                    <th> Operation Images</th>
                    <th> Operation Remark</th>
                  </tr>
                  </thead>
                  <tbody>
                  {currentIter.map((value, key) => {
                    return (
                      <tr key={key}>
                        <td>{value.material_name}</td>

                        <td>
                          {value?.m_image &&
                            <>
                            <div className='scrollable-img'>
                              {value.m_image.map((imgdoc, j) => {
                                return (
                                  <a href={imgdoc} target='_blank'>
                                    {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                              style={{
                                                                                "width": "80px",
                                                                                "borderRadius": "8px",
                                                                                "height": "57px",
                                                                                "border": "1px solid #555"
                                                                              }}/> <span className="space"></span> </> :
                                      imgdoc.split('.').pop() === 'jpeg' ? <> <img src={imgdoc}
                                                                                style={{
                                                                                  "width": "80px",
                                                                                  "borderRadius": "8px",
                                                                                  "height": "57px",
                                                                                  "border": "1px solid #555"
                                                                                }}/> <span className="space"></span> </> :
                                        imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                 style={{
                                                                                   "width": "80px",
                                                                                   "borderRadius": "8px",
                                                                                   "height": "57px",
                                                                                   "border": "1px solid #555"
                                                                                 }}/> <span className="space"></span></> :
                                          imgdoc.split('.').pop() === 'pdf' ? <>
                                            <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'doc' ? <>
                                              <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </> :
                                              ""
                                    }
                                  </a>
                                );
                              })}
                              </div>
                            </>
                          }
                        </td>
                        <td>{value.m_mat_status}</td>
                        <td>{value.m_remarks}</td>
                        <td>
                          {value?.ins_image &&
                            <>
                            <div className='scrollable-img'>
                              {value.ins_image.map((imgdoc, j) => {
                                return (
                                  <a href={imgdoc} target='_blank'>
                                    {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                              style={{
                                                                                "width": "80px",
                                                                                "borderRadius": "8px",
                                                                                "height": "57px",
                                                                                "border": "1px solid #555"
                                                                              }}/>  <span className="space"></span> </>:
                                      imgdoc.split('.').pop() === 'jpeg' ? <> <img src={imgdoc}
                                                                                style={{
                                                                                  "width": "80px",
                                                                                  "borderRadius": "8px",
                                                                                  "height": "57px",
                                                                                  "border": "1px solid #555"
                                                                                }}/> <span className="space"></span> </>:
                                        imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                 style={{
                                                                                   "width": "80px",
                                                                                   "borderRadius": "8px",
                                                                                   "height": "57px",
                                                                                   "border": "1px solid #555"
                                                                                 }}/> <span className="space"></span> </> :
                                          imgdoc.split('.').pop() === 'pdf' ? <>
                                            <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                            imgdoc.split('.').pop() === 'doc' ? <>
                                              <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </> :
                                              ""
                                    }
                                  </a>
                                );
                              })}
                              </div>
                            </>
                          }

                        </td>
                        <td>{value?.ins_remarks && value.ins_remarks}</td>

                      </tr>
                    );

                  })}
                  </tbody>
                </table>
                {/* <div className='card'> */}
                  <div className='card-body'>
                    <hr/>
                    <div className='row'>
                      <div className="col-md-2 col-sm-12">
                        <Button className='btn btn-primary' onClick={handleApprove}>
                          {localization.approve}
                        </Button>

                      </div>
                      <div className="col-md-2 col-sm-12">
                        <center><Button className='btn btn-danger' onClick={openRejectModal}>
                          {localization.reject}
                        </Button>
                        </center>
                      </div>
                    </div>

                  </div>
                {/* </div> */}

              </div>
            </div>
          }
          
        {/*Previous Hoto Iterations Start*/}
        {
          previousIter && previousIter?.length > 0 &&
          <>
            {previousIter.map((prevIt, key2) => {
              return(
              <div className="card mb-2">  
              <div className="card-header mb-3">
                HOTO Iteration {iterCount-key2}
                <span className='r-shiwt'>
                  ME: <b>{prevIt?.[0]?.m_name} ({prevIt?.[0]?.me_created_at})</b>
                </span>
                <span className='r-shiwt m-right'>
                  SE: <b>{prevIt?.[0]?.i_name} ({prevIt?.[0]?.se_updated_at})</b>
                </span>
              </div>
              <div className="card-body ml-2 mr-2">
              
                <table className='panel-table table table-striped mb-2' width="100%">
                  <thead>
                  <tr>
                    <th> Material</th>
                    <th> Maintenance Images</th>
                    <th> Material Status</th>
                    <th> Maintenance Remark</th>
                    <th> Operation Images</th>
                    <th> Operation Remark</th>
                  </tr>
                  </thead>
                  <tbody>
                  {prevIt.map((value, key3) => {
                    // {console.log(value)}
                    return (
                      <tr key={key3}>
                        <td>{value.material_name}</td>
                        <td>
                          {value?.m_image &&
                            <div className='scrollable-img'>
                            {value.m_image.map((imgdoc, j) => {
                              return (
                                <a href={imgdoc} target='_blank'>
                                  {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                            style={{
                                                                              "width": "80px",
                                                                              "borderRadius": "8px",
                                                                              "height": "57px",
                                                                              "border": "1px solid #555"
                                                                            }}/> <span className="space"></span> </>:
                                    imgdoc.split('.').pop() === 'jpeg' ? <>  <img src={imgdoc}
                                                                              style={{
                                                                                "width": "80px",
                                                                                "borderRadius": "8px",
                                                                                "height": "57px",
                                                                                "border": "1px solid #555"
                                                                              }}/> <span className="space"></span> </>:
                                      imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                style={{
                                                                                  "width": "80px",
                                                                                  "borderRadius": "8px",
                                                                                  "height": "57px",
                                                                                  "border": "1px solid #555"
                                                                                }}/> <span className="space"></span> </>:
                                        imgdoc.split('.').pop() === 'pdf' ?
                                          <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'doc' ?
                                            <> <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                            ""
                                  }
                                </a>
                              );
                            })}
                            </div>
                        }
                        </td>
                        <td>{value?.m_mat_status}</td>
                        <td>{value?.m_remarks}</td>
                        <td>{value?.ins_remarks}</td>
                        <td>
                          {value?.ins_image &&
                            <>
                              <div className='scrollable-img'>
                                {value.ins_image.map((imgdoc, j) => {
                                  return (
                                    <a href={imgdoc} target='_blank'>
                                      {imgdoc.split('.').pop() === 'png' ? <> <img src={imgdoc}
                                                                                    style={{
                                                                                      "width": "80px",
                                                                                      "borderRadius": "8px",
                                                                                      "height": "57px",
                                                                                      "border": "1px solid #555"
                                                                                    }}/>  <span className="space"></span> </>:
                                        imgdoc.split('.').pop() === 'jpeg' ? <> <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </>:
                                          imgdoc.split('.').pop() === 'jpg' ? <> <img src={imgdoc}
                                                                                      style={{
                                                                                        "width": "80px",
                                                                                        "borderRadius": "8px",
                                                                                        "height": "57px",
                                                                                        "border": "1px solid #555"
                                                                                      }}/> <span className="space"></span> </> :
                                            imgdoc.split('.').pop() === 'pdf' ? <>
                                                <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </>:
                                              imgdoc.split('.').pop() === 'doc' ? <>
                                                  <img src={Images?.DocIcon} alt="" className="view-icon"/> <span className="space"></span> </> :
                                                ""
                                      }
                                    </a>
                                  );
                                })}
                              </div>
                            </>
                          }
                        </td>

                      </tr>
                    );

                  })}
                  </tbody>
                </table>
              </div>
              </div>
              );
            })}
          </>
        }

        {/*Previos Hoto Iterations End*/}
        </div>
        <ModalPop
          title={localization.conf}
          show={isModal}
          handleModalHide={handleModalHide}
        >
          <div className="text-center">
            <div className="success">
              <img src={Images?.tick} alt=""/>
            </div>
            <h5>{modalMsg}</h5>
            <Link
              to={hotoDetails.hotoData?.status == 3 ? `${baseUrl}/hoto-m-approval/2/2` : `${baseUrl}/hoto-i-approval/1/2`}
              className="btn btn-primary mb-4"
            >
              Go to Listing! <img src={Images?.ArrowRight} alt=""/>
            </Link>

          </div>
        </ModalPop>

        <ModalPop
          title={localization.rejectConf}
          show={isRejectModal}
          handleModalHide={handleModalHide}
        >
            <Fragment>
              <div className="modal-body">
                <div className="text-center">
                  <h5>{localization.rejectHotoApproval}</h5>
                  <div className="form-group">
                    <ConstantInput
                      label={localization.addRemark}
                      required
                      isStarRequired={true}
                      type="text"
                      handleChange={(val) => {
                        setRemarks({ ...setRemarks, remarks: val });
                      }}
                    />
                  </div>
                  <Button
                    className="btn btn-primary"
                    onClick={handleReject}
                    disabled={!remarks.remarks}
                  >
                    {localization.continue}{' '}
                    <img src="../images/arrow-right.png" alt="" />
                  </Button>
                </div>
              </div>
            </Fragment>
        </ModalPop>

      </>
    </Layout>
  )
}

export default HotoApproval